<template>
  <v-menu
    offset-x
    open-on-hover
    min-width="10px"
  >
    <template v-slot:activator="{ on, attrs }">
      <div
        class="d-flex flex-grow-1 align-center gridSizeSelectorItem"
        v-bind="attrs"
        v-on="on"
      >
        <span
          class="flex-grow-1 tableMenuItemBtn"
        >
          {{ $t('components.editor.tableMenuActions.insert') }}
        </span>
        <v-spacer />
        <v-icon>arrow_right</v-icon>
      </div>
    </template>
    <v-list>
      <v-list-item>
        <div class="d-flex flex-column">
          <div
            class="squaresContainer"
            :style="`--nbCols: ${cols}; background-color: #F6F5FA;`"
            @mouseleave="reset"
          >
            <div
              v-for="(cell, idx) in numberCells"
              class="square"
              :row="cell.row"
              :col="cell.col"
              :key="idx"
              @mouseover="hover(cell)"
              @click="click(cell)"
            />
          </div>
          <span class="d-flex mt-1 justify-center" style="font-size: 12px;">
            {{ numberCols }} x {{ numberRows }}
          </span>
        </div>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'GridSizeSelector',
  data() {
    return {
      cols: 4,
      maxCols: 12,
      minCols: 4,
      rows: 3,
      maxRows: 6,
      minRows: 3,
      numberCols: 0,
      numberRows: 0,
    };
  },
  computed: {
    numberCells() {
      const ar = [];
      for (let row = 1; row <= this.rows; row++) {
        for (let col = 1; col <= this.cols; col++) {
          ar.push({ row, col });
        }
      }
      return ar;
    },
  },
  methods: {
    click(hoveredCell) {
      this.$emit('click', {
        rows: hoveredCell.row,
        cols: hoveredCell.col,
      });
    },
    hover(hoveredCell) {
      const whenToGrow = 1;
      const cellElems = document.getElementsByClassName('square');

      this.numberCols = hoveredCell.col;
      this.numberRows = hoveredCell.row;

      if ((hoveredCell.col > this.cols - whenToGrow) && (this.cols < this.maxCols)) {
        this.cols++;
      } else if ((hoveredCell.col < this.cols - whenToGrow) && (this.cols > this.minCols)) {
        this.cols--;
      }

      if ((hoveredCell.row > this.rows - whenToGrow) && (this.rows < this.maxRows)) {
        this.rows++;
      } else if ((hoveredCell.row < this.rows - whenToGrow) && (this.rows > this.minRows)) {
        this.rows--;
      }

      Array.from(cellElems).forEach(cellElem => {
        if (this.shouldHighlight(cellElem, hoveredCell)) {
          cellElem.style.backgroundColor = '#3C44C880';
        } else {
          cellElem.style.backgroundColor = 'white';
        }
      });
    },
    shouldHighlight(cellElem, hoveredCell) {
      return (cellElem.getAttribute('row') <= hoveredCell.row)
        && (cellElem.getAttribute('col') <= hoveredCell.col);
    },
    reset() {
      // This is to avoid seeing '0 x 0' momentarily before the menu is closed
      setTimeout(() => {
        this.hover({ col: 0, row: 0 });
        this.cols = this.minCols;
        this.rows = this.minRows;
      }, 100);
    },
  },
};
</script>

<style scoped>
.square {
  width: 15px;
  height: 15px;
  box-shadow: 0px 0px 2px -1px #888;
  border-radius: 2px;
  margin: 1px;
  background-color: white;
  cursor: pointer;
}

.squaresContainer {
  display: grid;
  grid-template-columns: repeat(var(--nbCols), 1fr);
  padding: 2px;
  border-radius: 4px;
}

::v-deep .v-list-item {
  padding: 0 4px;
}

.tableMenuItemBtn {
  padding: 0px 8px;
  font-size: 12px;
  height: 30px;
  display: inline-flex;
  align-items: center;
}
</style>
